const cities = [
  "Soho · London W1D",
  "Marylebone",
  "Mayfair",
  "Dubai Marina",
  "Upper East Side",
  "Knightsbridge",
  "Tribeca",
  "Notting Hill",
  "Palm Jumeirah",
  "Belgravia",
];

export default function Marquee() {
  const items = [...cities, ...cities];
  return (
    <div
      className="relative border-y border-white/10 bg-[#0B0E14] py-6 overflow-hidden no-scrollbar"
      data-testid="locations-marquee"
    >
      <div className="flex gap-16 whitespace-nowrap animate-marquee will-change-transform">
        {items.map((c, i) => (
          <span
            key={i}
            className="font-serif italic text-2xl sm:text-3xl text-[#F8F9FA]/40 flex items-center gap-16"
          >
            {c}
            <span className="w-1.5 h-1.5 bg-[#C5A059] rotate-45 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
